.selectContainer {
  width: 100%;
  box-sizing: border-box;

  .inlineLabel {
    max-width: 75%;
  }

  .labelComment {
    margin-left: 6px !important;
    color: #667885 !important;
  }
}
